import type { Locator } from "@readium/shared";

import type {
  Navigator,
  Selection,
} from "../../src/components/navigator/types";
import type { WPSClient } from "../../src/wps/client";
import type { FramePoolManager, FXLFramePoolManager } from "@readium/navigator";
import type { ClickedElement, Shortcut } from "../comm/types";

type EventDefinition<T> = {
  kind: "unique" | "multiple" | "unique-cached";
  data: T;
};

function make<T>(kind: EventDefinition<T>["kind"]): EventDefinition<T> {
  return { kind, data: null as unknown as T };
}

export default {
  "navigator:ready": make<{ navigator: Navigator; wpsClient: WPSClient }>(
    "unique-cached"
  ),
  "navigator:locator": make<Locator>("unique-cached"),
  "navigator:selection": make<Selection | null>("unique-cached"),
  "navigator:element-clicked": make<ClickedElement>("multiple"),
  "embed:shortcut": make<Shortcut>("multiple"),
  "epub:frame-pool-ready": make<FramePoolManager | FXLFramePoolManager>(
    "unique-cached"
  ),
} satisfies Record<string, EventDefinition<unknown>>;
